/** The slice of a React Query result a widget frame needs. */
export interface DataState {
  isLoading: boolean;
  isError: boolean;
  /** Fetching is switched off (permission / module) - nothing to show. */
  isDisabled?: boolean;
  refetch: () => unknown;
}

/** Collapse several queries into one state: loading while any is loading,
 * failed if any failed. Used by widgets that read more than one source. */
export function combineStates(...states: DataState[]): DataState {
  return {
    isLoading: states.some((s) => s.isLoading),
    isError: states.some((s) => s.isError),
    refetch: () => states.filter((s) => s.isError).forEach((s) => s.refetch()),
  };
}

